import { createSlice } from '@reduxjs/toolkit';
import type { LoteDetailError, LoteListItem, NegociacaoCasoNoLoteItem } from '../types/lotes.types';
import { fetchLoteDetail } from './actions';

interface LoteDetailState {
  lote: (LoteListItem & { updated_at: string }) | null;
  casos: NegociacaoCasoNoLoteItem[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
  loading: boolean;
  error: LoteDetailError | null;
}

const initialState: LoteDetailState = {
  lote: null,
  casos: [],
  pagination: { total: 0, page: 1, limit: 10, totalPages: 0 },
  loading: false,
  error: null,
};

const loteDetailSlice = createSlice({
  name: 'negociacoes/loteDetail',
  initialState,
  reducers: {
    clearLoteDetail: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLoteDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLoteDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.lote = action.payload.lote;
        state.casos = action.payload.casos;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchLoteDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? { message: 'Erro ao carregar detalhes do lote' };
      });
  },
});

export const { clearLoteDetail } = loteDetailSlice.actions;
export default loteDetailSlice.reducer;
